import classes from "./LoginButton.module.css";
import { ActionIcon, Center, Container, UnstyledButton } from "@mantine/core";
import { IconBrandSteam } from "@tabler/icons-react";
import { UserDisplay } from "../UserDisplay/UserDisplay";
import { useSession } from "../../auth/SessionContext";
import { DEBUG } from "../..";
import { steamLogin } from "../../auth/steamLogin";

export default function LoginButton(): React.JSX.Element {
  const { sessionData } = useSession();

  const handleSteamLogin = async () => {
    try {
      // Redirect to Steam auth; return to the LMUTV base after login.
      steamLogin();
    } catch (error) {
      if(DEBUG) console.error("Error initiating Steam login:", error);
    }
  };

  return (
    <>
      {sessionData?.logged_in ? (
        <UserDisplay />
      ) : (
        <Center>
          <UnstyledButton className={classes.steambutton} onClick={handleSteamLogin}>
          <span>Login</span>
          <Container className={classes.icon}>
            <Center>
              <ActionIcon
                size={42}
                variant="transparent"
                color="rgba(255, 255, 255, 1)">
                <IconBrandSteam />
              </ActionIcon>
            </Center>
          </Container>
        </UnstyledButton>
        </Center>
      )}
    </>
  );
}
